module.exports = __webpack_public_path__ + "img/concertina.fcadaf28.jpg";